<md-card class="login">
  <div class="title" md-card-image>Login</div>
  <form novalidate (ngSubmit)="submitLoginForm('1')" #loginForm="ngForm">
    <div *ngIf="loading">
      <sk-wave color="#d50032"></sk-wave>
    </div>
    <div *ngIf="errorMessage" class="error" [innerHtml]="errorMessage"></div>
    <md-form-field>
      <input
        name="username"
        mdInput
        placeholder="Username"
        autocomplete="off"
        [(ngModel)]="username"
        [disabled]="loading"
        required
        #loginInput
      />
      <md-error> Username is <strong>required</strong> </md-error>
    </md-form-field>
    <md-form-field>
      <input
        name="password"
        type="password"
        mdInput
        autocomplete="new-password"
        placeholder="Password"
        [(ngModel)]="password"
        [disabled]="loading"
        required
      />
      <md-error> Password is <strong>required</strong> </md-error>
    </md-form-field>
    <br />
  </form>
  <button
    *ngIf="!arkoseDisabled"
    id="button_login"
    md-raised-button
    color="accent"
    [disabled]="loading"
  >
    Login
  </button>
  <button
    *ngIf="arkoseDisabled"
    md-raised-button
    color="accent"
    [disabled]="loading"
    (click)="loginProcess()"
  >
    Login
  </button>
</md-card>
<p class="support">
  <a
    style="padding-left: 2px; vertical-align: middle"
    href="https://wbd.service-now.com/serviceportal?id=sc_cat_item&sys_id=0efc5ae21be3e550c59543b1b24bcb60"
    target="_blank"
  >
    Contact Support
  </a>
</p>



// WEBPACK FOOTER //
// ./src/app/pages/login/login.component.html